import React from 'react';
import { costOfInaction } from '../data/content';
export function CostSection() {
  return <section aria-labelledby="costo" className="bg-ink-900" data-id="element-34" data-mp="9bem7yndii15">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" style={{
      paddingTop: "14px",
      paddingBottom: "12px"
    }} data-id="element-35" data-mp="9e11ylkf43ug">
        <h2 id="costo" className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-36" data-mp="3vrisfd7a321s">
          ¿Cuánto te cuesta no tenerlo?
        </h2>

        <div className="scroll-shadow mt-10 overflow-x-auto rounded-2xl border border-ink-600" data-id="element-37" data-mp="3qtzfcgmbgvbf">
          <table className="w-full min-w-[560px] border-collapse text-left" data-id="element-38" data-mp="3mp9l0w7b3osm">
            <caption className="sr-only" data-id="element-39" data-mp="3hsswi0w738f0">
              Comparación entre trabajar sin Padel Pro-Pack y su costo real
            </caption>
            <thead data-id="element-40" data-mp="3curfdlibxj66">
              <tr className="bg-ink-800" data-id="element-41" data-mp="1g0d298cjz655">
                <th scope="col" className="px-6 py-4 text-xs font-bold uppercase tracking-[0.15em] text-slate-400" data-id="element-42" data-mp="1fzboux82e7k9">
                  Sin Padel Pro-Pack™
                </th>
                <th scope="col" className="px-6 py-4 text-xs font-bold uppercase tracking-[0.15em] text-red-400" data-id="element-43" data-mp="p71vviqt3naw">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-ink-600" data-id="element-44" data-mp="f9x678xr59pc">
              {costOfInaction.map(row => <tr key={row.without} className="bg-ink-900" data-id="element-45" data-mp="k88irrfflyb9">
                  <td className="px-6 py-4 text-sm text-slate-300" data-id="element-46" data-mp="k8qmf94fbet7">{row.without}</td>
                  <td className="px-6 py-4 text-sm font-semibold text-white" data-id="element-47" data-mp="17ykznrsnn5dz">{row.cost}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-10 font-display text-xl uppercase leading-tight text-court-200 sm:text-2xl" data-id="element-48" data-mp="y8rpmv85uybu">
          El próximo domingo puede ser diferente.
          <span className="mt-2 block text-ball-400" data-id="element-49" data-mp="135hzv1xaazpc">
            “Tu próxima clase puede ser la mejor que diste.” ⚡
          </span>
        </p>
      </div>
    </section>;
}